import {
  DuviSharedAdminButton as Button,
  DuviSharedAdminIcon as Icon,
} from "@duvi-agency/ui";
import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminKnowledgeBaseList } from "./use-duvi-core-admin-knowledge-base-list";
import { DuviCoreAdminKnowledgeBaseListView } from "./duvi-core-admin-knowledge-base-list-view";

export function DuviCoreAdminKnowledgeBaseList() {
  const state = useDuviCoreAdminKnowledgeBaseList();

  return (
    <DuviCoreAdminAppShell
      title="Knowledge base"
      subtitle="Articles across every category"
      breadcrumbs={["Knowledge Base"]}
      activeMenuItem="Knowledge Base"
      headerActions={
        <Button
          leftIcon={<Icon name="plus" size={15} />}
          onClick={state.openNew}
        >
          New article
        </Button>
      }
    >
      <DuviCoreAdminKnowledgeBaseListView {...state} />
    </DuviCoreAdminAppShell>
  );
}
